import { createAction } from 'deox';
import { GET_CATEGORIES, GET_CATEGORIES_SUCCESS, RESET_CATEGORIES } from './types';

export const resetCategories = createAction(RESET_CATEGORIES);
export const getCategories = {
  req: createAction(GET_CATEGORIES, (res) => (params) => res(params)),
  success: createAction(GET_CATEGORIES_SUCCESS, (res) => (params) => res(params)),
};
